import Vue from 'vue';

export default {
  props: {
    carouselContext: { type: Object, required: true }
  },
  methods: {
    incrementIndex: function() {
      if (this.carouselContext.index == this.carouselContext.itemCount - 1)
        this.carouselContext.index = 0;
      else this.carouselContext.index++;
    },
    decrementIndex: function() {
      if (this.carouselContext.index == 0) return;
      else this.carouselContext.index--;
    },
    incrementIndexAnd: function (callback){
      this.incrementIndex();
    },
    decrementIndexAnd: function (callback){
      this.decrementIndex();
    }
  },
  watch: {
    'carouselContext.index': function() {
      this.$emit('indexChanged', this.carouselContext.index);
    }
  }
}
